export enum Domains {
    VF = 'https://eweb8.vfd2-testnet.de',
    ZUHAUSEPLUS = 'https://zuhauseplus.vodafone.de',
    ST = 'https://simplicity.wf-de.vodafone.com'
}

export enum Endpoints {
    FF = '/api/friends-and-family/validate',
    LMS = '/api/ftth'
}

export enum QueryNames {
    TARIFF = 'product',
    GIGAKOMBI = 'gigakombi',
    FF = 'ffv2',
    BASKET = 'vfBasket',
    TARGET = 'target',
    OVERLAY = 'overlay',
    THREE_P = '3p',
}

export enum HttpStatus {
    UNAUTHORIZED = 401
}

export enum Cookies {
    ADDRESS = 'address',
    FF = 'vfhvalueffv2',
    BASKET = 'pdpBasket',
    ZHP_LM_MODULE = 'ftth',
    MDD_KEKS='MDDKeks',
    OSHOP = 'oshop',
    THREE_P = '3p',
    GIGAKOMBI = 'vf-gigakombi',
}

export enum LandingPagePath {
    DSL = '/privat/internet/dsl.html',
    CABLE = '/privat/internet/kabel.html',
    GIGACUBE = '/privat/internet/gigacube.html',
    PRE_FIBER = '/privat/internet/glasfaser/vorvermarktung.html',
}

export enum BasketPath {
    OPTION = '/optionen/',
    GIGAKOMBI = '/gigakombi/auth/'
}
